import React from "react";
import "./paymentmethod.css";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
const Paymentmethod = () => {
  return (
    <Container>
      <div className="paymentmethod">
        <div className="naqdi">
          {" "}
          <Link to='/user/naqdi' className="mainb" >
            التعامل النقدي <i className="fa-solid fa-money-bill-trend-up"></i>
          </Link>
        </div>
        <div className="banqi">
          {" "}
          <Link  to='/user/online' className="mainb" >
            التعامل عن طريق بوابات الدفع الألكترونية <i className="fa-solid fa-credit-card"></i>
          </Link>
        </div>
        <div className="banqi">
          {" "}
          <Link  to='/user/banki' className="mainb" >
            التعامل البنكي <i className="fa-solid fa-building-columns"></i>
          </Link>
        </div>
      </div>
    </Container>
  );
};

export default Paymentmethod;
